import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForConcept,
    withUpdateConcept,
} from "src/modules/concept/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateConcept } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateConcept(values);
        router.push("/concept");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForConcept, withUpdateConcept)(Edit);
